<template>
<div ref="scrollChecker">
 <div ref="scrollingElement" >
    <p v-scroll="handleScroll" @click="teamInfo" v-for="team in teams" :key="team.id" :id="team.id" :class="team.class == 'heading-class' ? 'heading-class' : 'team mt-5'">
    <span v-if="team.class== 'heading-class'"> {{team[sorting_param]}}</span>
    <span v-else>{{team.name}}</span>
    <span class="hidden">{{team.id}}</span>
    </p>
</div>
</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import axios from 'axios';
import { debounce } from 'lodash';

export default {
  name: 'team-list-mobile',
  props: ['sorting_func', 'sorting_param', 'getTeamsOnRerender'],
  data() {
    return {
      base: process.env.VUE_APP_MP_PARTNERS_BACKEND,
      preventRepetitionArray: [],
      pageNumber: 1,
      teams: [],
    };
  },
  directives: {
    scroll: {
      inserted(el, binding) {
        const f = function (evt) {
          if (binding.value(evt, el)) {

          }
        };
        window.addEventListener('scroll', f);
      },
    },
  },
  computed: {
    ...mapState({
      formCity: state => state.auth.user.city_id,
    }),
  },
  created() {
    this.getTeams();
  },
  methods: {
    teamInfo(e) {
      const paragraph = e.target.closest('p');
      const classList = Array.from(paragraph.classList);
      if (classList.includes('team')) {
        const arrayOfIds = this.teams.map(team => team.id);
        const objectIndex = arrayOfIds.indexOf(paragraph.id++);
        this.$router.push({
          name: 'info',
          params: {
            teamObject: this.teams[objectIndex],
            play_count: this.teams[objectIndex].play_count,
            type: 'database',
          },
        });
      }
    },
    getTeams() {
      axios.get(`${this.base}/teams?sort=name,-id&city_id=${this.formCity}&limit=50&page[number]=${this.pageNumber}&sort=${this.sorting_func}`)
        .then(({ data }) => {
          this.checkData(data.data, this.sorting_param);
        });
    },
    checkData(arr, sortingParam) {
      const len = arr.length;
      const firstHeading = sortingParam == 'name' ? arr[0].name.toUpperCase().charAt(0) : arr[0].play_count;
      this.insertData(arr[0], firstHeading, sortingParam);

      for (let i = 1; i < len; i++) {
        const currentHeading = sortingParam == 'name' ? arr[i].name.toUpperCase().charAt(0) : arr[i].play_count;
        const prevHeading = sortingParam == 'name' ? arr[i - 1].name.toUpperCase().charAt(0) : arr[i - 1].play_count;

        if (currentHeading != prevHeading) {
          this.insertData(arr[i], currentHeading, sortingParam);
        } else { this.teams.push(arr[i]); }
      }
    },
    insertData(object, data, sortingParam) {
      if (this.preventRepetitionArray.includes(data)) {
        this.teams.push(object);
        return;
      }
      this.preventRepetitionArray.push(data);
      const regExp = new RegExp('[a-zA-Z0-9а-яА-Я]');
      if (sortingParam == 'name' && !regExp.test(data)) {
        this.teams.push(object);
      } else {
        const headingObject = Object.assign({}, object);
        if (sortingParam == 'name') {
          headingObject.name = data;
        } else {
          headingObject.play_count = data;
        }
        headingObject.id = Math.random() * 1000;
        headingObject.class = 'heading-class';
        this.teams.push(headingObject);
        this.teams.push(object);
      }
    },
    handleScroll: debounce(function (evt, el) {
      if (window.scrollY + 550 > this.$refs.scrollingElement.scrollHeight) {
        this.pageNumber++;

        axios.get(`${this.base}/teams?sort=name,-id&city_id=${this.formCity}&limit=50&page[number]=${this.pageNumber}&sort=${this.sorting_func}`)
          .then(({ data }) => this.checkData(data.data, this.sorting_param));
      }
    }, 1000),
  },
};
</script>
<style scoped>
.heading-class {
    font-size: 14px;
    font-weight: bold;
    color: #979797;
    border-bottom: 1px solid #979797;
    padding-bottom: 2px;
    margin-bottom: 20px;
    margin-top: 20px;
}
</style>
